import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  MdCheck,
} from "react-icons/md";
import { CategorizedFacility, getCategoryIcon } from "../constants";



const PremiumAmenities: FC<{ facilities: CategorizedFacility[] }> = ({ facilities }) => {
  const { t } = useTranslation();
  if (!facilities.length) return null;

  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold text-font-default">{t("Hotels.booking.premiumFacilities")}</h3>
      <div className="flex flex-col">
        {facilities.map((facility) => {
          const CategoryIcon = getCategoryIcon(facility?.category);
          return (
            <div
              key={facility?.category}
              className="flex flex-col gap-3 border-b border-border-subtle py-4 last:border-b-0 md:flex-row md:items-start md:gap-6"
            >
              <div className="flex shrink-0 items-center gap-2 md:w-56  md:pr-6 h-full">
                <CategoryIcon className="h-5 w-5 shrink-0 text-icon-active"/>
                <span className="font-semibold text-font-default">
                  {facility?.category ? t(`Hotels.booking.facilityCategories.${facility.category}`, { defaultValue: facility.category }) : ""}
                </span>
              </div>
              <div className="w-px self-stretch bg-border-subtle"/>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                {facility?.category && facility?.items?.map((item) => (
                  <div key={item} className="flex items-center gap-1.5 text-sm text-font-subtle">
                    <MdCheck className="h-4 w-4 shrink-0 text-font-subtle" />
                    <span>{t(`Hotels.booking.facilityItems.${item}`, { defaultValue: item })}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PremiumAmenities;
